import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { AuthServiceService as AuthGaurd} from './auth-service.service';

import { UpcomingAssessmentModule } from "../app/application/pages/upcoming-assessment/upcoming-assessment.module";

export const routes: Routes = [

  {
    path: '',
    redirectTo: 'scora-participant/home',
    pathMatch: 'full',
    canActivate: [AuthGaurd]
  },
  { path: 'scora-participant', loadChildren: './application/pages/scora-participant/scora-participant.module#ScoraParticipantModule', canActivate: [AuthGaurd] },
  { path: 'scora-participant-assessment', loadChildren: './application/pages/upcoming-assessment/upcoming-assessment.module#UpcomingAssessmentModule',canActivate: [AuthGaurd] },
  { path: 'scora-profile', loadChildren: './application/pages/profile/profile.module#ProfileModule',canActivate: [AuthGaurd] },
  { path: 'scora-insight', loadChildren: './application/pages/insights/insights.module#InsightsModule',canActivate: [AuthGaurd]},
  // { path: 'scora-insight', loadChildren: '../app/author/author.module#AuthorModule' },


  // {
  //   path: '',
  //   redirectTo: 'user',
  //   pathMatch: 'full',
  //   canActivate: [AuthGaurd]
  // },

  // {
  //   path: '',
  //   data: {
  //     title: 'Home'
  //   },
  //   children: [
  //     {
  //       path: 'user',
  //       loadChildren: './author/author.module#AuthorModule',
  //       canActivate: [AuthGaurd]
  //     }
  //   ]
  // },

  
  // {
  //   path: '',
  //   data: {
  //     title: 'Test Admin'
  //   },
  //   children: [
  //     {
  //       path: 'testadmin',
  //       loadChildren: './test-admin/test-admin.module#TestAdminModule'
  //     }
  //   ]
  // },
  
  // {
  //   path: 'pages',
  //   component: FullLayoutComponent,
  //   data: {
  //     title: 'Pages'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: './pages/pages.module#PagesModule',
  //     }
  //   ]
  // }
];

@NgModule({
  // imports: [ RouterModule.forRoot(routes,{ preloadingStrategy: PreloadAllModules }) ],
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts